import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { GuestUserPopup } from 'components/GuestUserPopup';
import CountBox from 'components/common/CountBox';
import HeaderStrip from 'components/common/Header/HeaderStrip';
import NotificationDropdown from 'components/common/Header/NotificationDropdown';
import HeaderSearch from 'components/common/Header/Search';
import HeaderAccountList from 'components/common/HeaderAccountList';
import HeaderRightSidebar from 'components/common/HeaderRightSidebar';
import DefaultUser from 'components/common/UserProfileDefault';

import { Storage } from 'services/Storage';

import { IntlMessage } from 'util/IntlMessages';
import { getUserName, isObject } from 'util/utils';

import { trackTypeObj, commonLogout, LOCAL_STORAGE_VAR, BASE_URL_ATTACH } from 'constants/Common';
import { GET_DASHBOARD_DATA, GET_EVENTS, GET_NOTIFICATIONS } from 'constants/apiConstant';

import { setLoader, covidStrip } from '../appRedux/actions/Common';
import { getSearchList } from '../containers/APIFunctions';
import UtilService from '../services/util';

import notificationWhiteSvg from 'assets/svg/Header/notification-white.svg';
import notificationSvg from 'assets/svg/Header/notification.svg';
import searchWhiteSvg from 'assets/svg/Header/search-white.svg';
import searchSvg from 'assets/svg/Header/search.svg';
import userWhiteSvg from 'assets/svg/Header/user-white.svg';
import userSvg from 'assets/svg/Header/user.svg';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      isHovered1: false,
      isHovered2: false,
      covid: true,
      search: false,
      details: {},
      HeaderStripList: true,
      counts: {},
      rates: {},
      notifications: 0,
      event: [],
      searchList: [],
      isGuest: localStorage.getItem(`${LOCAL_STORAGE_VAR}-guest`),
      showGuest: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.deleteReminder.count !== prevProps.deleteReminder.count) {
      this.getSidebarCounts();
      this.getNotifications();
    }
  }

  componentDidMount() {
    this.getSidebarCounts();
    this.getEvents();
    this.getNotifications();
    this.props.covidStrip(this.state.covid);
    getSearchList((list) => this.setState({ searchList: list }));
  }

  closeStrip = () => {
    this.props.covidStrip(!this.props.commonData.strip);
    this.setState({ covid: false });
  };

  searchOption = () => {
    if (!this.state.isGuest) {
      this.setState({ search: !this.state.search });
    } else {
      this.setState({ showGuest: true });
    }
  };

  showGuest = () => this.setState({ showGuest: true });

  handleHover = () => this.setState({ isHovered: !this.state.isHovered, isHovered1: false, isHovered2: false });

  handleHover1 = () => this.setState({ isHovered1: !this.state.isHovered1, isHovered: false, isHovered2: false });

  handleHover2 = () => this.setState({ isHovered2: !this.state.isHovered2, isHovered: false, isHovered1: false });

  handleOut = () => this.setState({ isHovered: false });

  handleOut1 = () => this.setState({ isHovered1: false });

  handleOut2 = () => this.setState({ isHovered2: false });

  HeaderStripCick = () => {
    this.props.covidStrip(!this.props.commonData.strip);
    this.setState({ HeaderStripList: !this.state.HeaderStripList });
  };

  getSidebarCounts = () => {
    const request = {
      savedSearch: true,
      recentSearch: true,
      track: true,
      orderData: true,
      dashboardCount: true,
      shippingCount: true,
      seller: true,
      account: true,
    };

    UtilService.callApi({ ...GET_DASHBOARD_DATA, request }, (err, res) => {
      const { tracks, orderData, ...rest } = res.data ?? {};

      const counts = { ...rest };
      counts.order = orderData.reduce(
        (p, c) => ({ carat: p.carat + c.carat, totals: p.totals + c.totals, pieces: p.pieces + c.pieces }),
        { carat: 0, totals: 0, pieces: 0 },
      );

      if (res && res.code === 'OK') {
        this.setState({ details: res.data.tracks, rates: res.data.rates, counts });
      }
    });
  };

  getEvents = () => {
    const obj = { ...GET_EVENTS, request: { page: 1, limit: 10, type: 6 } };
    UtilService.callApi(obj, (err, res) => {
      if (res && res.code === 'OK') {
        if (res.data) {
          const eventData = res.data.list[0];
          this.setState({ event: eventData });
        }
      }
    });
  };

  getNotifications = () => {
    const obj = { ...GET_NOTIFICATIONS };
    UtilService.callApi(obj, (err, res) => {
      if (res && res.code === 'OK') {
        if (res.data) this.setState({ notifications: res.data.unReadCount });
      }
    });
  };

  render() {
    const isGuest = localStorage.getItem(`${LOCAL_STORAGE_VAR}-guest`);

    const btnClass = this.state.isHovered ? 'active' : '';
    const btnClass1 = this.state.isHovered1 ? 'active' : '';
    const btnClass2 = this.state.isHovered2 ? 'active' : '';

    const user = Storage.get('user') ?? {};
    const profileImage = user.profileImage;
    const name = getUserName(user);

    const USER_PERMIT = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-userPermissions`);

    const HeaderLinks = [
      USER_PERMIT?.CART?.view && {
        link: '/account/cart',
        title: <IntlMessage id="app.my-cart" />,
        details: this.state.details[trackTypeObj.CART],
        basicDetailnull: true,
      },
      USER_PERMIT?.WATCHLIST?.view && {
        link: '/account/watchlist',
        title: <IntlMessage id="app.my-watchlist" />,
        details: this.state.details[trackTypeObj.WATCHLIST],
        basicDetailnull: true,
      },
      USER_PERMIT?.OFFICE?.view && {
        link: '/account/office-list',
        title: <IntlMessage id="app.office-list" />,
        details: this.state.details[trackTypeObj.REQUEST],
        basicDetailnull: true,
      },
      USER_PERMIT?.CONFIRM_STONE?.view && {
        link: '/account/confirm-list',
        title: <IntlMessage id="app.confirm-list" />,
        details: this.state.counts.order,
        basicDetailnull: true,
      },
      USER_PERMIT?.QUOTE?.view && {
        link: '/account/quote-list',
        title: <IntlMessage id="app.MyOfferList" />,
        details: this.state.details[trackTypeObj.QUOTE],
        basicDetailnull: true,
      },
      USER_PERMIT?.NOTES?.view && {
        link: '/account/notes',
        title: <IntlMessage id="app.my-comment" />,
        details: this.state.details[trackTypeObj.COMMENT],
        basicDetailnull: true,
      },
      // USER_PERMIT?.MY_BID?.view && {
      //   link: '/my-bid',
      //   title: <IntlMessages id="app.myBid" />,
      //   // basicDetailnull: true,
      // },
      !isGuest &&
        USER_PERMIT?.SAVE_SEARCH?.view && {
          link: '/account/saved-search',
          title: <IntlMessage id="app.saved-search" />,
          // basicDetailnull: true,
        },
      !isGuest &&
        USER_PERMIT?.DEMAND?.view && {
          link: '/account/my-demand',
          title: <IntlMessage id="app.my-demand-tab" />,
          // basicDetailnull: true,
        },

      {
        link: '/account/profile',
        title: <IntlMessage id="app.MyProfile" />,
        // basicDetailnull: true,
      },

      {
        link: '',
        title: <IntlMessage id="app.SignOut" />,
        onClick: () => {
          commonLogout();
        },
        // basicDetailnull: true,
      },
    ].filter(isObject);

    return (
      <>
        <div className="HeaderSticky">
          <div className={`headerTopMenu ${this.state.covid && 'active'}`}>
            {/* {this.state.HeaderStripList && (
              <UpDownBox onClick={this.HeaderStripCick} />
            )}
            {!this.state.HeaderStripList && (
              <UpDownBox downArrow onClick={this.HeaderStripCick} />
            )} */}
            <div className="headerWrapper">
              <div className="headerLeft"></div>
              <div className="headerRightSide">
                <div className={`headerRightBlock ${btnClass || btnClass1 || btnClass2}`}>
                  <div className="headerIcon" onClick={this.searchOption}>
                    <img className="defulticon" src={searchSvg} alt="icon" />
                    <img className="hoverIcon" src={searchWhiteSvg} alt="icon" />
                  </div>
                  <HeaderSearch
                    className={this.state.search && 'active'}
                    onClick={this.searchOption}
                    searchList={this.state.searchList}
                  />
                  <div className="headerRightOption" onMouseEnter={this.handleHover} onClick={this.handleHover}>
                    <div className="headerIcon" onMouseEnter={this.handleHover2} onClick={this.handleHover2}>
                      <img className="defulticon" src={notificationSvg} alt="icon" />
                      <img className="hoverIcon" src={notificationWhiteSvg} alt="icon" />
                      {this.state.notifications > 0 && <CountBox count={this.state.notifications} />}
                    </div>
                    <Link to="/account/profile" className="headerIcon">
                      <img className="defulticon" src={userSvg} alt="icon" />
                      <img className="hoverIcon" src={userWhiteSvg} alt="icon" />
                      <span className="headerUserName">
                        <IntlMessage id="app.Welcome" />, {name}
                      </span>
                    </Link>
                    <HeaderRightSidebar activeClass={btnClass} handleOut={this.handleOut} onClick={this.handleOut}>
                      <div className="dropdownUserIcon">
                        <div className="userProfileLogo">
                          {profileImage ? (
                            <img src={`${BASE_URL_ATTACH}/${profileImage}`} alt="user" />
                          ) : (
                            <DefaultUser />
                          )}
                        </div>
                        <div className="userProfileContent">
                          <h2>{name}</h2>
                          <p onClick={() => window.location.assign('/account/profile')}>
                            <IntlMessage id="app.SeeYourProfile" />
                          </p>
                        </div>
                      </div>
                      <div className="userDetailList">
                        <ul>
                          {HeaderLinks.map((item) => (
                            <HeaderAccountList
                              key={item?.link}
                              isGuest={this.state.isGuest}
                              showGuest={this.showGuest}
                              {...item}
                            />
                          ))}
                        </ul>
                      </div>
                    </HeaderRightSidebar>
                  </div>

                  <div className="headerRightOption">
                    <HeaderRightSidebar activeClass={btnClass2} handleOut={this.handleOut2} onClick={this.handleOut2}>
                      <NotificationDropdown count={this.state.notifications} updatedCount={this.getNotifications} />
                    </HeaderRightSidebar>
                  </div>
                  <HeaderStrip />
                </div>
              </div>
            </div>
          </div>
          <div className="headerStrip"></div>

          {this.state.showGuest && (
            <GuestUserPopup
              visible={this.state.showGuest}
              register={() => {
                window.open('/signup', '_this');
                window.localStorage.clear();
                window.sessionStorage.clear();
              }}
              handleCancel={() => {
                this.setState({ showGuest: false });
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default compose(
  connect(
    (store) => ({
      deleteReminder: store?.deleteReminder,
      commonData: store?.commonData,
    }),
    { setLoader, covidStrip },
  ),
  withRouter,
)(Header);
